export enum KeyType {
  Public = "publicKey",
  Private = "privateKey",
  Password = "password",
}

export default KeyType;
